export default __webpack_public_path__ + "static/media/studenthelper_slide3.d2e39de4.png";